import { SIDEBAR_MESSAGES, SidebarMessages } from "../../layout/sidebar";
import {
  WhatsappBspCompletionMessages,
  whatsappBspCompletionMessages,
} from "./whatsappBspCompletionMessages";
import {
  WhatsappBspOnboardingLinkMessages,
  whatsappBspOnboardingLinkMessages,
} from "./whatsappBspOnboardingLinkMessages";
import {
  WhatsappBspOverviewMessages,
  whatsappBspOverviewMessages,
} from "./whatsappBspOverviewMessages";

export type WhatsAppBspConnectionMessages = SidebarMessages &
  WhatsappBspOverviewMessages &
  WhatsappBspOnboardingLinkMessages &
  WhatsappBspCompletionMessages & {
    pageTitle: string;
    breadCrumbTitle: string;

    nextButton: string;
    completeButton: string;

    overviewStepTitle: string;
    onboardingLinkStepTitle: string;
    completionStepTitle: string;
  };

export const WHATSAPP_BSP_CONNECTION_MESSAGES: WhatsAppBspConnectionMessages = {
  ...SIDEBAR_MESSAGES,
  pageTitle: "WhatsApp",
  breadCrumbTitle: "Plataformas",

  nextButton: "Próximo",
  completeButton: "Concluir",

  overviewStepTitle: "Visão Geral",
  onboardingLinkStepTitle: "Complete seu onboarding",
  completionStepTitle: "Finalização",

  ...whatsappBspOverviewMessages,
  ...whatsappBspOnboardingLinkMessages,
  ...whatsappBspCompletionMessages,
};

